<script lang="ts">
    import MainLayout from "../../../#common/layout/Layout.svelte"
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte.js'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte.js'
    import Pagination from 'src/components/cabinet/#common/pagination/Pagination.svelte.js'
    import {Link} from 'svelte-routing'
    import Transactions from 'src/components/cabinet/#common/transactions/Transactions.svelte'
    import IconifyIcon from '@iconify/svelte'
    import copyIcon from '@iconify/icons-fa-solid/copy'
    import {
        copyClipboard,
        delay,
        numberWithSpaces,
        navigate
    } from 'src/components/cabinet/#common/helpers'
    import {myBalance} from "src/components/cabinet/#services/myBalance"
    import {
        checkMyTransactionForCurrency,
        getTestnetLis,
        myTransactionsByCurrency
    } from 'src/components/cabinet/#services/myTransactions'
    import {buyWallet, getMyWallet} from 'src/components/cabinet/#services/nearAdapter'
    import backIcon from 'src/components/cabinet/#assets/left-icon.svg'
    import arrowsIcon from '../../arrows.svg'
    import transferIcon from '../../transfer.svg'
    import buyIcon from './../../buy.svg'
    import swapIcon from '../../transfer.svg'
    import infoIcon from '../../info.svg'
    import QrCode from 'svelte-qrcode'
    import {roundNumber} from 'src/components/#common/helpers/helpers'
    import {showAlert} from 'src/components/#common/alert/store'
    import Transfer from 'src/components/cabinet/account/components/Transfer/Transfer.svelte'
    import Ramp from 'src/components/cabinet/account/components/Ramp/Ramp.svelte'
    import {getMyEthWallet, getUserTempWallet, startDepositTracking} from 'src/components/cabinet/#services/evmAdapter'
    import Network from 'src/components/cabinet/account/components/Network/Network.svelte'

    export let balance

    if (!balance || innerWidth > 767) {
        navigate('/account')
    }

    $: innerWidth

    if (!['drag', 'near', 'usdt', 'matic', 'dogecoin', 'pepe'].includes(balance)) { navigate("/account") }

    let selectedNetwork = 'Near'
    let depositSelectedCurrency
    let modalWindowStatus = false
    let depositModalOpen = false
    let buyModalOpen = false
    let amount
    let walletAddress
    let loading = false
    let transferFrom
    let transferTo
    if (balance === 'drag') { transferFrom = 'DRAG'; transferTo = 'LIS' }
    if (balance === 'dogecoin') { transferFrom = 'DOGE'; transferTo = 'WDOGE' }
    if (balance === 'pepe') { transferFrom = 'PEPE'; transferTo = 'WPEPE' }
    if (balance === 'usdt') { transferFrom = 'USDT'; transferTo = 'WUSDT' }
    let transferModalOpen = false
    let currencies = { drag: 'DRAG', near: 'NEAR', usdt: 'USDT', matic: 'MATIC', testnet: 'TLIS', dogecoin: 'DOGE', pepe: 'PEPE' }
    let balanceName = { LIS: 'DRAG', DRAG: 'DRAG', NEAR: 'NEAR', USDT: 'USDT', MATIC: 'MATIC', TLIS: 'Testnet', DOGE: 'DOGE', PEPE: 'PEPE' }
    let outerWidth
    let currentPage = 0
    let perPage = 10
    let transactions

    getMyWallet.send()
    getMyEthWallet.send()
    checkMyTransactionForCurrency.reset()
    checkMyTransactionForCurrency.send({ data: { currency: 'TLIS', reason: "nearTestnet" }})
    $: myTransactionsByCurrency.send({ data: { currency: currencies[balance], page: currentPage + 1, perPage } })
    getUserTempWallet.send()

    $: modalWindowStatus, modalWindowStatus !== true ? buyModalOpen = modalWindowStatus : false

    function getTotalBalance(balance) {
        if (!$myBalance.hasValue) return 0

        if (balance == 'drag') {
            return roundNumber($myBalance.value?.data.LIS + $myBalance.value?.data.PLIS + $myBalance.value?.data.BLIS + $myBalance.value?.data.DRAG + $myBalance.value?.data.PWLIS)
        } else if (balance == 'testnet') {
            return roundNumber($myBalance.value?.data.TLIS)
        } else {
            return roundNumber($myBalance.value?.data[balance.toUpperCase()])
        }
    }

    function getMainBalance(balance) {
        if (!$myBalance.hasValue) return 0

        if (balance == 'drag') {
            return roundNumber($myBalance.value?.data.LIS + $myBalance.value?.data.PLIS + $myBalance.value?.data.BLIS + $myBalance.value?.data.DRAG + $myBalance.value?.data.PWLIS)
        } else if (balance == 'dogecoin') {
            return roundNumber($myBalance.value?.data.DOGE + $myBalance.value?.data.WDOGE + $myBalance.value?.data.PDOGE + $myBalance.value?.data.PWDOGE + $myBalance.value?.data.BDOGE)
        } else if (balance == 'pepe') {
            return roundNumber($myBalance.value?.data.PEPE + $myBalance.value?.data.WPEPE + $myBalance.value?.data.PPEPE + $myBalance.value?.data.PWPEPE + $myBalance.value?.data.BPEPE)
        } else if (balance == 'testnet') {
            return roundNumber($myBalance.value?.data.TLIS)
        } else {
            return roundNumber($myBalance.value?.data[balance.toUpperCase()])
        }
    }

    function getPurchasedBalance() {
        if (!$myBalance.hasValue) return 0

        return roundNumber($myBalance.value?.data.PLIS + $myBalance.value?.data.PWLIS)
    }

    function selectDepositCurrency() {
        if (balance == 'wallet') {
            depositSelectedCurrency = 'DRAG'
        } else {
            depositSelectedCurrency = balance.toUpperCase()
        }
    }

    async function buyWalletHandler() {
        try {
            loading = true
            await buyWallet.request()
            getMyWallet.reset()
            getMyWallet.send()
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
            depositModalOpen = false
        } finally {
            loading = false
        }
    }

    async function getTestnetLisHandler() {
        try {
            await getTestnetLis.request()

            showAlert.set({
                status: 'success',
                text: 'You have successfully received 100 DRAG for testing'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            myBalance.send()
            checkMyTransactionForCurrency.reset()
            checkMyTransactionForCurrency.send({ data: { currency: 'TLIS', reason: "nearTestnet" }})
        }
    }

    async function copy(event, value) {
        let button = event.currentTarget
        button.setAttribute('data-tooltip', 'Copied')
        copyClipboard(value)
        await delay(2500)
        button.removeAttribute('data-tooltip')
    }

    $: outerWidth, buyModalOpen = false, modalWindowStatus = false
</script>

<svelte:head>
    <title>{balance.toUpperCase()}</title>
</svelte:head>

<svelte:window bind:outerWidth />

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <Alert />
            <div class="page-title">
                <Link to="account" class="btn btn-second back"><img src={backIcon} alt=""> Back</Link>
                {balance.toUpperCase()}
            </div>
            <div class="balance-card">
                <div class="balance-row">
                    <div class="balance-amount big-balance notranslate">
                        {!$myBalance.hasValue ? ".." : numberWithSpaces(getMainBalance(balance))}
                        {balanceName[currencies[balance]]}
                    </div>
                </div>
                {#if balance === 'drag' && $myBalance.hasValue}
                    <div class="balance-row">
                        <div class="label">Wallet balance</div>
                        <div class="balance-amount notranslate">
                            {!$myBalance.hasValue ? ".." : numberWithSpaces($myBalance.value?.data.DRAG + $myBalance.value?.data.PWLIS)}
                            DRAG
                        </div>
                    </div>
                    <div class="balance-row">
                        <div class="label">Game balance</div>
                        <div class="balance-amount notranslate">
                            {!$myBalance.hasValue ? ".." : numberWithSpaces(roundNumber($myBalance.value?.data.LIS + $myBalance.value?.data.PLIS + $myBalance.value?.data.BLIS))}
                            DRAG
                        </div>
                    </div>
                {/if}
                <div class="balance-actions">
                    {#if balance === 'testnet' && $checkMyTransactionForCurrency.hasValue && $checkMyTransactionForCurrency.value.count === 0}
                        <button class="balance-btn" on:click={getTestnetLisHandler}>
                            <div><img src="{arrowsIcon}" alt=""></div>Get Free
                        </button>
                    {/if}
                    {#if ['dogecoin', 'pepe'].includes(balance) || (balance === 'drag' && $myBalance.hasValue && ($myBalance.value?.data.DRAG > 0 || $myBalance.value?.data.PWLIS > 0)) }
                        <button class="balance-btn" on:click={() => {transferModalOpen = true}}>
                            <div><img src="{transferIcon}" alt=""></div>Transfer
                        </button>
                    {/if}
                    {#if ['near', 'usdt', 'matic', 'pepe', 'dogecoin'].includes(balance) || (balance === 'drag' && $myBalance.hasValue && ($myBalance.value?.data.LIS > 0 || $myBalance.value?.data.PLIS > 0 || $myBalance.value?.data.DRAG > 0 || $myBalance.value?.data.PWLIS > 0))}
                        <Link to="swap" class="balance-btn">
                            <div><img src="{swapIcon}" class="icon-90-rotate" alt=""></div>Swap
                        </Link>
                    {/if}
                    {#if ['near'].includes(balance)}
<!--                        <button class="balance-btn" on:click={() => {selectDepositCurrency(); depositModalOpen = true}} disabled={!$getMyWallet.hasValue}>-->
<!--                            <div><img src="{arrowsIcon}" alt=""></div>Deposit-->
<!--                        </button>-->
                    {/if}
                    {#if ['drag'].includes(balance)}
                        <button class="balance-btn" on:click={() => {
                            selectedNetwork = 'BNB Chain';
                            startDepositTracking.send({ data: { currency: 'DRAG' } })
                            selectDepositCurrency();
                            depositModalOpen = true
                        }}>
                            <div><img src="{arrowsIcon}" alt=""></div>Deposit
                        </button>
                    {/if}
                    {#if [ 'near', 'matic', 'dogecoin', 'pepe'].includes(balance)}
                        <button class="balance-btn" disabled>
                            <div><img src="{arrowsIcon}" alt=""></div>Deposit
                        </button>
                    {/if}
                    {#if ['usdt'].includes(balance)}
                        <button class="balance-btn" on:click={() => {
                            selectedNetwork = 'BNB Chain';
                            startDepositTracking.send({ data: { currency: 'USDT' } })
                            selectDepositCurrency();
                            depositModalOpen = true
                        }}>
                            <div><img src="{arrowsIcon}" alt=""></div>Deposit
                        </button>
                    {/if}
                    {#if ['near', 'matic'].includes(balance)}
                        <button class="balance-btn" disabled>
                            <div><img src="{arrowsIcon}" alt=""></div>Withdraw
                        </button>
                    {/if}
                    {#if balance === 'drag' && $myBalance.hasValue && ($myBalance.value?.data.LIS > 0 || $myBalance.value?.data.PLIS > 0 || $myBalance.value?.data.DRAG > 0 || $myBalance.value?.data.PWLIS > 0)}
                        <Link to="withdrawal" class="balance-btn">
                            <div><img src="{arrowsIcon}" alt=""></div>Withdraw
                        </Link>
                    {/if}
                    {#if balance === 'near'}
<!--                        <Link to="withdrawal?t=NEAR" class="balance-btn">-->
<!--                            <div><img src="{arrowsIcon}" alt=""></div>Withdraw-->
<!--                        </Link>-->
                    {/if}
                    {#if balance === 'usdt'}
                        <Link to="withdrawal?t=USDT" class="balance-btn">
                            <div><img src="{arrowsIcon}" alt=""></div>Withdraw
                        </Link>
                    {/if}
                    {#if balance === 'matic'}
<!--                        <Link to="withdrawal?t=MATIC" class="balance-btn">-->
<!--                            <div><img src="{arrowsIcon}" alt=""></div>Withdraw-->
<!--                        </Link>-->
                    {/if}
                </div>
            </div>
            <div class="balance-card transactions-history">
                <div class="card-title">History</div>
                {#if $myTransactionsByCurrency.loading}
                    <Transactions/>
                {:else if $myTransactionsByCurrency.error || !$myTransactionsByCurrency.hasValue }
                    Something went wrong. Try refreshing the page.
                {:else if $myTransactionsByCurrency.hasValue}
                    <Transactions transactions={$myTransactionsByCurrency.value.data}/>
                    <Pagination bind:currentPage={currentPage} totalCount={$myTransactionsByCurrency.value.totalCount} {perPage}/>
                {/if}
            </div>
        </div>
        <Modal bind:visible={depositModalOpen}>
            <svelte:fragment slot="content">
                {#if $getUserTempWallet.loading || !$getUserTempWallet.hasValue}
                    <div class="modal-custom__title">Loading...</div>
                    <div class="modal-custom__text text-center">Loading...</div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { depositModalOpen = false }}>Cancel</button>
                        <button class="btn btn-primary" disabled>Loading...</button>
                    </div>
                
                {:else if selectedNetwork === 'BNB Chain' && $getUserTempWallet.hasValue && $getUserTempWallet.value}
                    <div class="modal-custom__title">Deposit {depositSelectedCurrency}</div>
                    <div class="modal-custom__text">
                        <Network bind:selectedNetwork selectedCurrency={depositSelectedCurrency} />
                        Send your <span class="notranslate">{depositSelectedCurrency}</span> to the wallet address below:
                        <div class="wallet-actions">
                            <input class="form-control w-100" value="{$getUserTempWallet?.value}" readonly>
                            <button on:click={(e) => copy(e, $getUserTempWallet?.value) } class="btn btn-primary copy-btn">
                                <IconifyIcon icon="{copyIcon}"/>
                            </button>
                        </div>
                        <div class="text-center">
                            <QrCode value="{$getUserTempWallet?.value}" background="#ffffff" color="#27272F" size="200"/>
                        </div>
                    </div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { depositModalOpen = false }}>Close</button>
                    </div>
                {/if}
            </svelte:fragment>
        </Modal>
        <Modal bind:visible={buyModalOpen}>
            <svelte:fragment slot="content">
                {#if $getMyWallet.loading || !$getMyWallet.hasValue}
                    <div class="modal-custom__title">Loading...</div>
                    <div class="modal-custom__text text-center">Loading...</div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { buyModalOpen = false }}>Cancel</button>
                        <button class="btn btn-primary" disabled>Loading...</button>
                    </div>
                {:else if $getMyWallet.hasValue && !$getMyWallet.value}
                    <div class="modal-custom__title">Buy a deposit wallet</div>
                    <div class="modal-custom__text text-center">
                        A wallet address for buying <span class="notranslate">{balance.toUpperCase()}</span> costs 0.1 <span class="notranslate">USDT</span>.<br>
                    </div>
                    <div class="modal-custom__footer">
                        <button class="btn btn-cancel" on:click={() => { buyModalOpen = false }}>Cancel</button>
                        <button class="btn btn-primary" on:click={buyWalletHandler} class:loading={loading} disabled={loading}>Buy</button>
                    </div>
                {:else if $getMyWallet.hasValue && $getMyWallet.value}
                    <div class="modal-custom__title">Buy {balance.toUpperCase()}</div>
                    <div class="modal-custom__text">
                        <Ramp bind:modalWindowStatus walletAddress={walletAddress} currency={balance}/>
                    </div>
                {/if}
            </svelte:fragment>
        </Modal>
        <Transfer bind:transferModalOpen={transferModalOpen} transferFrom={transferFrom} transferTo={transferTo}/>
    </svelte:fragment>
</MainLayout>

<style>
    .balance-card {
        background: #26244D;
        border: 2px solid #494591;
        border-radius: 10px;
        padding: 20px 15px 90px;
        height: 100%;
        position: relative;
        margin-bottom: 10px;
        transition: .25s;
    }

    .deposit-notice {
        margin: 12px 0;
        font-size: 14px;
        background: rgba(244, 67, 54, 0.37);
        padding: 10px;
        border-radius: 6px;
    }

    .icon-90-rotate {
        transform: rotate(90deg);
    }

    .transactions-history {
        padding-bottom: 20px;
    }

    .balance-row {
        display: flex;
        justify-content: space-between;
    }

    .balance-row:not(:first-child) {
        margin-top: 15px;
    }

    .label {
        font-size: 15px;
        color: #CAD5E0;
        line-height: 1;
    }

    .balance-amount {
        font-size: 15px;
        color: white;
        font-weight: 600;
        line-height: 1;
    }

    .purchased-tooltip {
        display: inline-block;
        vertical-align: top;
        margin: 1px 0 -1px 1px;
    }

    .purchased-tooltip img {
        vertical-align: top;
    }

    .balance-actions {
        margin-top: 19px;
        display: flex;
        justify-content: center;
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        bottom: 20px;
    }

    .purchased-tooltip .tooltip {
        opacity: 0;
        visibility: hidden;
        background: #61758a;
        font-size: 12px;
        color: white;
        line-height: 1.2;
        padding: 5px 10px;
        transform: translateX(-50%);
        margin-left: 8px;
        margin-top: 12px;
        min-width: 200px;
        max-width: 200px;
        text-align: center;
        border-radius: 3px;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
        transition: opacity .2s, margin .2s;
    }

    .auto-width-tooltip .tooltip {
        min-width: initial;
    }

    .purchased-tooltip .tooltip:after {
        content: "";
        position: absolute;
        border: 8px solid transparent;
        border-bottom: 8px solid #61758a;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
    }

    .purchased-tooltip:hover .tooltip {
        display: block;
        opacity: 1;
        visibility: visible;
        margin-top: 8px;
    }

    .card-title {
        margin-bottom: 20px;
        text-align: left;
        font-size: 15px;
        font-weight: 500;
        color: white;
        line-height: 1;
    }

    .transfer-window {
        background: #585f67;
        border: 1px solid #CAD5E0;
        border-radius: 5px;
    }

    .transfer-row {
        padding: 15px;
        position: relative;
    }

    .transfer-row:first-child {
        border-bottom: 1px solid #CAD5E0;
    }

    .transfer-toggle {
        position: absolute;
        top: -20px;
        right: 20px;
        width: 40px;
        height: 40px;
        background: #FF5D1C;
        border: 1px solid #CAD5E0;
        border-radius: 50%;
    }

    .transfer-row label {
        font-size: 14px;
        color: #CAD5E0;
        line-height: 1;
    }

    .form-control.transfer-amount {
        font-size: 25px;
        line-height: 30px;
        padding: 0;
        margin: 10px 0;
        outline: none;
        box-shadow: none;
        font-weight: 600;
    }

    .btn-max-amount {
        font-size: 18px;
        line-height: 18px;
        color: #CAD5E0;
        box-shadow: none;
    }

    .wallet-actions {
        white-space: nowrap;
        display: flex;
        align-items: center;
        margin: 20px 0;
    }

    .wallet-actions .form-control {
        box-shadow: inset 0 0 0 2px #ccccd5;
        color: white;
        width: auto;
        padding: 12px 16px;
        max-width: 100%;
        overflow: hidden;
        display: inline-block;
        cursor: text;
    }

    .wallet-actions .btn.btn-primary.copy-btn {
        padding: 14px;
        vertical-align: top;
        margin: 0 0 0 10px;
        width: 48px;
        min-width: 48px;
        height: 48px;
        font-size: 16px;
    }

    .wallet-main-balance img {
        width: 40px;
        height: 40px;
        margin-right: 10px;
    }

    .wallet-lis-address span {
        opacity: 0.6;
        border-bottom: 1px solid white;
        font-size: 16px;
        line-height: 18px;
        font-weight: 300;
    }

    .big-balance {
        text-align: center;
        width: 100%;
        font-size: 20px;
    }

    .balance-actions .icon-rotate {
        transform: rotate(90deg);
    }

    @media(max-width: 767px) {
        .transfer-toggle {
            top: -15px;
            right: 15px;
            width: 30px;
            height: 30px;
        }

        :global(.balance-card .panel-gray) {
            padding: 0 !important;
        }

        .purchased-tooltip {
            margin: -2px 0 -1px 1px;
        }
    }
</style>
